@if (_gS.loading) {
  <div class="loader"></div>
}
<div class="menu-bar">
  @if (showMenu) {
    <app-menu-bar></app-menu-bar>
  }
</div>
<div class="content">
  <router-outlet (window:beforeunload)="doBeforeUnload($event)"></router-outlet>
</div>
<footer>
  Copyright © {{ _gS.actualYear }} Sony Pictures Television Inc. {{'All Rights Reserved' | translate}}. {{_gS.version}}
  @if (_gS.getLenguage() === 'esp' || _gS.getLenguage() === 'pt') {
    <a (click)="changeLenguage('eng')">English version</a>
  }
  @if (_gS.getLenguage() === 'eng' || _gS.getLenguage() === 'pt') {
    <a (click)="changeLenguage('esp')">Versión español</a>
  }
  @if (_gS.getLenguage() === 'eng' || _gS.getLenguage() === 'esp') {
    <a (click)="changeLenguage('pt')"> - Versión português</a>
  }
</footer>